import React, { useCallback } from 'react';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from './authConfig';
import useIdleTimeout from './useIdleTimeout';

export default function AuthGuard({ children }) {
  const { instance, inProgress } = useMsal();

  const handleIdle = useCallback(() => {
    instance.logoutRedirect();
  }, [instance]);
  useIdleTimeout(handleIdle);

  if (inProgress !== InteractionStatus.None) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <p>Laden...</p>
      </div>
    );
  }

  return (
    <>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            gap: '1rem',
          }}
        >
          <h2>BPMN Editor</h2>
          <p>Bitte melden Sie sich mit Ihrem Weissenberg-Konto an.</p>
          <button
            className="btn btn-primary btn-lg"
            onClick={() => instance.loginRedirect(loginRequest)}
          >
            Mit Microsoft anmelden
          </button>
        </div>
      </UnauthenticatedTemplate>
    </>
  );
}
